var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    { staticClass: "item", class: { "tile-item": !_vm.inModal } },
    [
      _c("div", [
        _c("b", [
          _vm._v(
            "Сообщение №" +
              _vm._s(_vm.leasing.notification_number) +
              " от " +
              _vm._s(_vm.dateParser(_vm.leasing.notification_date))
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "item__status" }, [
        _c("b", [_vm._v("Статус:")]),
        _vm._v(" "),
        _c(
          "span",
          {
            class: {
              green: _vm.leasing.contract_status,
              red: !parseInt(_vm.leasing.contract_status),
            },
          },
          [_vm._v(_vm._s(_vm._f("getStatus")(_vm.leasing.contract_status)))]
        ),
        _vm._v(" "),
        _vm.leasing.contract_cancel_reason
          ? _c("span", [
              _vm._v("(" + _vm._s(_vm.leasing.contract_cancel_reason) + ")"),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "item__lessor" },
        [
          !_vm.leasing.lessors.length > 1
            ? _c("b", [_vm._v("Лизингодатель:")])
            : _c("b", [_vm._v("Лизингодатели:")]),
          _vm._v(" "),
          _vm.leasing.lessors.length === 0
            ? _c(
                "span",
                { staticClass: "cursor-help", attrs: { title: _vm.lawDescr } },
                [
                  _vm._v(
                    "Сведения скрыты в соответствии с требованиями постановления Правительства РФ от 12.01.2018 г. №5"
                  ),
                ]
              )
            : _vm.leasing.lessors.length === 1
            ? _c("participant", {
                attrs: { participant: _vm.leasing.lessors[0] },
              })
            : _c(
                "ul",
                _vm._l(_vm.leasing.lessors, function (l, i) {
                  return _c(
                    "li",
                    { key: i },
                    [_c("participant", { attrs: { participant: l } })],
                    1
                  )
                }),
                0
              ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "item__lessees" },
        [
          !_vm.leasing.lessees.length > 1
            ? _c("b", [_vm._v("Лизингополучатель:")])
            : _c("b", [_vm._v("Лизингополучатели:")]),
          _vm._v(" "),
          _vm.leasing.lessees.length === 0
            ? _c(
                "span",
                { staticClass: "cursor-help", attrs: { title: _vm.lawDescr } },
                [
                  _vm._v(
                    "Сведения скрыты в соответствии с требованиями постановления Правительства РФ от 12.01.2018 г. №5"
                  ),
                ]
              )
            : _vm.leasing.lessees.length === 1
            ? _c("participant", {
                attrs: { participant: _vm.leasing.lessees[0] },
              })
            : _c(
                "ul",
                _vm._l(_vm.leasing.lessees, function (l, i) {
                  return _c(
                    "li",
                    { key: i },
                    [_c("participant", { attrs: { participant: l } })],
                    1
                  )
                }),
                0
              ),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "item__period" }, [
        _c("b", [_vm._v("Срок финансовой аренды:")]),
        _vm._v(" "),
        _c("span", [
          _vm._v(
            "\n            " +
              _vm._s(_vm.dateParser(_vm.leasing.leasing_interval_start)) +
              " - " +
              _vm._s(_vm.dateParser(_vm.leasing.leasing_interval_end)) +
              "\n        "
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.inModal
        ? _c("div", { staticClass: "item__details" }, [
            _vm.leasing.contract_number
              ? _c("div", [
                  _c("b", [_vm._v("Договор:")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.leasing.contract_number))]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.leasing.subjects.length > 0
              ? _c("div", [
                  _c("b", [_vm._v("Предметы финансовой аренды:")]),
                  _vm._v(" "),
                  _c("table", { staticClass: "subjects-table" }, [
                    _vm._m(0),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.leasing.subjects, function (s, i) {
                        return _c("tr", { key: i }, [
                          _c("td", [
                            _vm._v(_vm._s(s.SubjectId ? s.SubjectId : "")),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(s.ClassifierName ? s.ClassifierName : "")
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(_vm._s(s.Description ? s.Description : "")),
                          ]),
                        ])
                      }),
                      0
                    ),
                  ]),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Идентификатор")]),
        _vm._v(" "),
        _c("th", [_vm._v("Классификация")]),
        _vm._v(" "),
        _c("th", [_vm._v("Описание")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }